import { LegalLayout, LegalSection } from "@/components/landing/LegalLayout";

export default function Datenschutz() {
  return (
    <LegalLayout
      title="Datenschutzerklärung"
      subtitle="Informationen zur Verarbeitung personenbezogener Daten gemäß DSGVO"
    >
      <LegalSection heading="1. Verantwortlicher">
        <p>
          Verantwortlich für die Datenverarbeitung auf dieser Website ist:
          <br />
          Kurier Connect, Kolja Kramer
          <br />
          Feldstraße 83A, 25421 Pinneberg
          <br />
          E-Mail: info@kurier-connect.de
        </p>
      </LegalSection>

      <LegalSection heading="2. Allgemeines zur Datenverarbeitung">
        <p>
          Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur
          Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen
          erforderlich ist. Die Verarbeitung erfolgt auf Grundlage der geltenden gesetzlichen
          Bestimmungen (insb. DSGVO und BDSG).
        </p>
      </LegalSection>

      <LegalSection heading="3. Aufruf der Website / Server-Logfiles">
        <p>
          Beim Aufrufen unserer Website werden durch den Hosting-Anbieter automatisch Informationen
          erfasst (z.&nbsp;B. IP-Adresse, Datum und Uhrzeit des Zugriffs, verwendeter Browser und
          Betriebssystem). Diese Daten dienen der technischen Bereitstellung sowie der Sicherheit und
          Stabilität. Rechtsgrundlage ist Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO (berechtigtes
          Interesse). [Bitte Hosting-Anbieter ergänzen.]
        </p>
      </LegalSection>

      <LegalSection heading="4. Webinar-Anmeldung über WebinarGeek">
        <p>
          Auf dieser Website ist ein Anmeldeformular des Anbieters <strong>WebinarGeek B.V.</strong>{" "}
          (Niederlande) eingebunden. Wenn du dich für ein Webinar anmeldest, werden die von dir
          eingegebenen Daten (z.&nbsp;B. Vorname, E-Mail-Adresse, ggf. weitere Angaben) an WebinarGeek
          übermittelt und dort verarbeitet, um deine Anmeldung zu ermöglichen und dir Informationen zum
          Webinar zuzusenden.
        </p>
        <p>
          Rechtsgrundlage ist Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;b DSGVO (Durchführung
          vorvertraglicher/vertraglicher Maßnahmen) bzw. Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;a DSGVO
          (Einwilligung). Weitere Informationen findest du in der Datenschutzerklärung von WebinarGeek:
          [Link zur WebinarGeek-Datenschutzerklärung einfügen].
        </p>
      </LegalSection>

      <LegalSection heading="5. Cookies">
        <p>
          Unsere Website verwendet ggf. Cookies. Cookies sind kleine Textdateien, die auf deinem
          Endgerät gespeichert werden. Technisch notwendige Cookies werden auf Grundlage von
          Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO gesetzt. Für nicht notwendige Cookies (z.&nbsp;B.
          Analyse) holen wir, sofern erforderlich, deine Einwilligung ein (Art.&nbsp;6 Abs.&nbsp;1
          lit.&nbsp;a DSGVO).
        </p>
      </LegalSection>

      <LegalSection heading="6. Reichweitenmessung (First-Party)">
        <p>
          Zur Ermittlung der Besucherzahlen setzen wir eine eigene, serverseitige
          Reichweitenmessung ein (ohne Drittanbieter, ohne Weitergabe an Dritte). Dabei wird bei einem
          Seitenaufruf ein anonymisierter, zufällig erzeugter Kennwert (im lokalen Speicher deines
          Browsers), die aufgerufene Seite, die Herkunft (Referrer) sowie der Browsertyp gespeichert,
          um Aufrufe und ungefähre Besucherzahlen auszuwerten.
        </p>
        <p>
          Es werden keine IP-Adressen gespeichert und es findet keine Zusammenführung mit anderen
          Daten oder eine Profilbildung statt. Rechtsgrundlage ist Art.&nbsp;6 Abs.&nbsp;1
          lit.&nbsp;f DSGVO (berechtigtes Interesse an einer statistischen Auswertung der Reichweite).
          Du kannst der Messung widersprechen, indem du den lokalen Speicher deines Browsers löschst.
        </p>
      </LegalSection>

      <LegalSection heading="7. Deine Rechte als betroffene Person">
        <p>Dir stehen nach der DSGVO insbesondere folgende Rechte zu:</p>
        <ul className="list-disc space-y-1 pl-5">
          <li>Recht auf Auskunft (Art.&nbsp;15 DSGVO)</li>
          <li>Recht auf Berichtigung (Art.&nbsp;16 DSGVO)</li>
          <li>Recht auf Löschung (Art.&nbsp;17 DSGVO)</li>
          <li>Recht auf Einschränkung der Verarbeitung (Art.&nbsp;18 DSGVO)</li>
          <li>Recht auf Datenübertragbarkeit (Art.&nbsp;20 DSGVO)</li>
          <li>Recht auf Widerspruch (Art.&nbsp;21 DSGVO)</li>
          <li>Recht auf Widerruf einer erteilten Einwilligung (Art.&nbsp;7 Abs.&nbsp;3 DSGVO)</li>
        </ul>
      </LegalSection>

      <LegalSection heading="8. Beschwerderecht bei der Aufsichtsbehörde">
        <p>
          Unbeschadet eines anderweitigen Rechtsbehelfs steht dir das Recht auf Beschwerde bei einer
          Datenschutz-Aufsichtsbehörde zu, insbesondere in dem Mitgliedstaat deines Aufenthaltsorts,
          deines Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes.
        </p>
      </LegalSection>

      <LegalSection heading="9. Kontakt in Datenschutzfragen">
        <p>Bei Fragen zum Datenschutz kannst du uns unter info@kurier-connect.de erreichen.</p>
      </LegalSection>
    </LegalLayout>
  );
}
